import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerAddonAll: [],
  insurerAddon: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerAddonSlice = createSlice({
  name: "insurerAddon",
  initialState,
  reducers: {
    setInsurerAddonAll: (state, action) => {
      state.insurerAddonAll = action.payload;
    },
    setInsurerAddon: (state, action) => {
      state.insurerAddon = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerAddonAll,
  setInsurerAddon,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerAddonSlice.actions;

export default insurerAddonSlice.reducer;
